/**
 * Пользовательское правило.
 *
 * Третья сущность платформы, рядом с индикатором терминала и авторским
 * ботом, и смешивать её ни с тем, ни с другим нельзя.
 *
 * Индикатор терминала рисует линию и ничего не утверждает. Авторский
 * бот — отдельный процесс со своей математикой, которая версионируется
 * вместе с ним: если бы он брал вычисления у графика, правка отрисовки
 * молча меняла бы его сигналы. Правило — третий случай: описание у него
 * одно, создал его сам человек, и смысл именно в том, что срабатывает
 * ровно то, что он видит на экране.
 *
 * Поэтому одно описание читают все: график, уведомления, проверка на
 * истории и, если человек захочет, торговля. Расхождение между «на
 * графике стрелка, а бот не купил» здесь невозможно по построению.
 *
 * **Закон платформы: сигнал подтверждается только закрытой свечой.**
 * На формирующейся условие может выполняться и перестать выполняться;
 * это предварительное состояние, а не сигнал. Иначе человек сделает
 * снимок экрана со стрелкой, которая через минуту исчезнет, — и это
 * разрушает доверие быстрее любой ошибки в расчётах.
 */
/** Группа это или условие. */
export function isGroup(node) {
    return node.kind === 'group';
}
/* ---------------------------------------------------- чтение обеих форм */
/**
 * Условия правила независимо от того, как оно записано.
 *
 * Профиль живёт дольше кода: правила, созданные до появления групп,
 * лежат плоским списком с «и» между условиями. Разбирать это в каждом
 * месте, где нужны условия, значит рано или поздно забыть в одном из
 * них — и правило поведёт себя по-разному на графике и в уведомлении.
 */
export function groupOf(rule) {
    if (rule.when)
        return rule.when;
    return { kind: 'group', join: 'and', items: rule.conditions ?? [] };
}
/** Пустое ли правило: без условий оно не срабатывает никогда. */
export function isEmptyGroup(group) {
    if (group.items.length === 0)
        return true;
    return group.items.every((item) => isGroup(item) && isEmptyGroup(item));
}
/** Все условия дерева подряд — для подписей и проверки таймфреймов. */
export function flattenConditions(node) {
    if (!isGroup(node))
        return [node];
    return node.items.flatMap(flattenConditions);
}
//# sourceMappingURL=rule.js.map